export default __webpack_public_path__ + "static/media/img_about-m.520783a8.jpg";